import { Component } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { LoginService } from './login.service';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedService } from 'src/app/core/shared/shared.service';
import { switchMap, take, tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputTextModule, PasswordModule, ButtonModule, FormsModule, CheckboxModule, ToastModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService]
})
export class LoginComponent {
  loginForm: FormGroup;
  checked: boolean = false;
  user: any;

  constructor(private fb: FormBuilder, private router: Router, private loginService: LoginService, private sharedService: SharedService, private messageService: MessageService) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      checked: [false],
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.loginService.login(this.loginForm.value).pipe(
        tap(response => this.storeUserData(response)),
        switchMap(() => this.sharedService.loadCurrentUser()),
        switchMap(() => this.sharedService.currentUser$.pipe(take(1)))
      ).subscribe({
        next: user => {
          console.log("USER--->", user)
          if (user.user_type === 'super_admin') {
            this.router.navigate(['/properties']);
            return;
          }
          if (user.user_type === 'tenant') {
            this.router.navigate(['/tenants-portal']);
            return;
          }
          this.user = user;
          this.router.navigate(['/dashboard']);
        },
        error: (err: { error: { message: any; }; }) => {
          console.log("ERR--->", err)
          this.messageService.add({
            severity: 'error',
            summary: 'Login Failed',
            detail: err.error?.message || 'Something went wrong. Try again!',
          });
        },
      });
    }
  }

  navigateToForgetPassword() {
    this.router.navigate(['/forgot-password']);
  }

  private storeUserData(res: any) {
    localStorage.setItem('accessToken', res.accessToken);
  }

}
